import { SocialProfilesAnalytics } from '../../AnalyticsProvider';
import { SocialProfile } from '../../../../components/socialProfiles/SocialProfile';
import { profilesHelpers } from '../../../Settings/Profiles/Profiles.helpers';
import React from 'react';
import classes from './ChartLegendSocialProfiles.module.scss';
import { AnalyticsVisualizationType } from '../../AnalyticsDashboard/AnalyticsDashboard.controller';

export const ChartLegendSocialProfilesView = ({
  socialProfiles,
  view
}: {
  socialProfiles: SocialProfilesAnalytics[];
  view: AnalyticsVisualizationType | undefined;
}) => {
  return (
    <div className={classes.ChatLegendContainer}>
      {view === AnalyticsVisualizationType.overview &&
        socialProfiles.map(profile => (
          <div key={profile.id}>
            <SocialProfile
              socialProfile={{
                id: profile.id,
                provider: profilesHelpers.mapOAuthFromTypename(profile.__typename),
                network: profilesHelpers.mapNetworkFromTypename(profile.__typename),
                name: profile.displayName
              }}
              size={'small'}
              image={profile.photoUrl}
              label={true}
            />
          </div>
        ))}
    </div>
  );
};
